import axiosInstance from "../../axiosInstance";

const BASE = "/elearning/certificate-requests";

export const getCertRequestSchools = async (branchId) => {
  const res = await axiosInstance.get(`${BASE}/meta/schools`, {
    params: { branch_id: branchId },
  });
  return res.data;
};

export const getCertRequestClasses = async ({ branch_id, unit, school_id }) => {
  const res = await axiosInstance.get(`${BASE}/meta/classes`, {
    params: { branch_id, unit, school_id },
  });
  return res.data;
};

export const getCertRequestClassStudents = async (classId) => {
  const res = await axiosInstance.get(`${BASE}/meta/class/${classId}/students`);
  return res.data;
};

export const createCertificateRequest = async (body) => {
  const res = await axiosInstance.post(BASE, body);
  return res.data;
};

export const downloadTeacherCertRequestTemplate = async () => {
  const res = await axiosInstance.get(`${BASE}/teacher/import-template`, {
    responseType: "blob",
  });
  return res.data;
};

export const createTeacherCertificateRequest = async (formData) => {
  const res = await axiosInstance.post(`${BASE}/teacher`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const listCertificateRequests = async (params = {}) => {
  const res = await axiosInstance.get(BASE, { params });
  return res.data;
};

export const getCertificateRequestById = async (id) => {
  const res = await axiosInstance.get(`${BASE}/${id}`);
  return res.data;
};

export const getCertificatesForRequest = async (requestId) => {
  const res = await axiosInstance.get(`${BASE}/${requestId}/certificates`);
  return res.data;
};

export const approveCertificateRequestHq = async (id, body = {}) => {
  const res = await axiosInstance.post(`${BASE}/${id}/approve-hq`, body);
  return res.data;
};

export const approveCertificateRequestMgmt = async (id) => {
  const res = await axiosInstance.post(`${BASE}/${id}/approve-mgmt`);
  return res.data;
};

export const rejectCertificateRequest = async (id, body = {}) => {
  const res = await axiosInstance.post(`${BASE}/${id}/reject`, body);
  return res.data;
};

export const deleteCertificateRequest = async (id, body = {}) => {
  const res = await axiosInstance.delete(`${BASE}/${id}`, { data: body });
  return res.data;
};

export const bulkApproveCertificateRequestsHq = async (body = {}, config = {}) => {
  const res = await axiosInstance.post(`${BASE}/bulk-approve-hq`, body, {
    timeout: 600000,
    ...config,
  });
  return res.data;
};

export const bulkApproveCertificateRequestsMgmt = async (body = {}, config = {}) => {
  const res = await axiosInstance.post(`${BASE}/bulk-approve-mgmt`, body, {
    timeout: 600000,
    ...config,
  });
  return res.data;
};
